import React, {useCallback, useRef, useState} from 'react';
import classNames from 'classnames';

const MultiSelectDropdownItem = ({checked, id, label, onChange, value}) => (
    <label className="dropdown-item d-flex align-items-center mb-0" htmlFor={`${id}-${value}`}>
        <input className="mr-2" type="checkbox" id={`${id}-${value}`} value={value} checked={checked} onChange={onChange} />
        {label}
    </label>
);

const truncate = (text, maxLength) => (text.length > maxLength ? `${text.slice(0, maxLength)}…` : text);

// eslint-disable-next-line react/no-multi-comp
const MultiSelectField = ({field, form, id, options, maxLength = 32}) => {
    const [open, setOpen] = useState(false);
    const blurTimerRef = useRef(null);
    const values = field.value || [];
    const selectedLabel = options.filter((option) => values.includes(option.value)).map((option) => option.label).join(', ');

    const toggleOpen = useCallback((e) => {
        e.preventDefault();
        setOpen((prevOpen) => !prevOpen);
    }, []);

    const handleFocus = useCallback(() => {
        if (blurTimerRef.current) clearTimeout(blurTimerRef.current);
    }, []);

    const handleBlur = useCallback(() => {
        blurTimerRef.current = setTimeout(() => setOpen(false), 150);
    }, []);

    const handleChange = useCallback((e) => {
        const optionValue = e.target.value;
        const currentValues = field.value || [];
        if (e.target.checked) {
            form.setFieldValue(field.name, currentValues.concat(optionValue));
        } else {
            form.setFieldValue(field.name, currentValues.filter((value) => value !== optionValue));
        }
    }, [field.name, field.value, form]);

    return (
        <div className={classNames('dropdown', 'multi-select-field', {show: open})} onFocus={handleFocus} onBlur={handleBlur}>
            <button type="button"
                className="btn btn-outline-secondary dropdown-toggle d-flex align-items-center justify-content-between w-100"
                onClick={toggleOpen}>
                <span className="text-truncate" style={{minWidth: 0, flex: '1 1 auto', textAlign: 'left'}}>
                    {truncate(selectedLabel, maxLength) || '—'}
                </span>
            </button>
            <div className={classNames('dropdown-menu', {show: open})}>
                {options.map(({value, label}) => (
                    <MultiSelectDropdownItem key={value} id={id} value={value} label={label}
                        checked={values.includes(value)} onChange={handleChange} />
                ))}
            </div>
        </div>
    );
};

export default MultiSelectField;
